$("#campeonatoGrupoSortable").on("sortout",function(){
    var id_reg_campeonatos_grupo = [];
    $(this).find('li').each(function(){
        id_reg_campeonatos_grupo.push($(this).find('.id').html());
    });
    var id_reg_campeonatos = $("[name=id]").val();
    var data = {
        'id_reg_campeonatos':id_reg_campeonatos,
        'campeonatos_grupo':id_reg_campeonatos_grupo
    }
    $.post('/api/campeonato/'+id_reg_campeonatos+'/ordenar_grupos',data,function(){
    });
})